import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Currency from '../Currency';
import { LAYOUT } from '../Layout/enums';

import defaultOfferingImage from '../../assets/images/default-offering-image.png';

import './index.css';
import { offeringCategory } from '../../helpers/mappings';

const getOfferStatus = (status, category) => {
  switch (status.toLowerCase()) {
    case 'active': {
      if (category === offeringCategory.COMING_SOON.value || category === offeringCategory.TESTING_WATERS.value) {
        return {
          display: 'Upcoming',
          styleName: 'statusUpcoming',
        };
      }
      return {
        display: 'Active',
        styleName: 'statusAct',
      };
    }
    case 'pending':
      return {
        display: 'Pending Order',
        styleName: 'statusPending',
      };
    default:
      return {
        display: 'Closed',
        styleName: 'statusInact',
      };
  }
};


const StandardOffering = (props) => {
  const { layout, offering, showPendingStatus } = props;

  let offerStyle = 'standOfferDesk';
  let standImgStyle = 'standImgDesk';
  let standOfferNameStyle = 'standOfferNameDesk';
  let standOfferIndStyle = 'standOfferIndDesk';
  let standOfferAmtStyle = 'standOfferAmtDesk';
  let standOfferMinLblStyle = 'standOfferMinInvLblDesk';
  let standOfferNewLblStyle = 'standOfferNewLblDesk';
  let standOfferComingSoonLblStyle = 'standOfferComingSoonLblDesk';
  const offerStatus = getOfferStatus(showPendingStatus ? 'pending' : offering.status, offering.category);

  switch (layout) {
    case LAYOUT.TAB:
      offerStyle = 'standOfferTab';
      standImgStyle = 'standImgTab';
      offerStatus.styleName = `${offerStatus.styleName}Desk`; // Same as desktop
      break;
    case LAYOUT.MOB:
      offerStyle = 'standOfferMob';
      standImgStyle = 'standImgMob';
      standOfferNameStyle = 'standOfferNameMob';
      offerStatus.styleName = `${offerStatus.styleName}Mob`;
      standOfferIndStyle = 'standOfferIndMob';
      standOfferAmtStyle = 'standOfferAmtMob';
      standOfferMinLblStyle = 'standOfferMinInvLblMob';
      standOfferNewLblStyle = 'standOfferNewLblMob';
      standOfferComingSoonLblStyle = 'standOfferComingSoonLblMob';
      break;
    default:
      offerStatus.styleName = `${offerStatus.styleName}Desk`;
      break;
  }


  let asset = {};
  if (offering.assets && offering.assets.length) {
    [asset] = offering.assets;
  }
  const { previewImageUrl, url } = asset;
  const imgSrc = (previewImageUrl || url) || defaultOfferingImage;
  const currency = !offering.minimumInvestCurrencyAmt ? (
    <div
      style={{
        'letter-spacing': '0.4px',
        'font-family': '"Source Sans Pro", sans-serif',
        'text-align': 'left',
        'font-size': '23px',
        'padding-left': '17px',
        'font-weight': 'bold',
      }}
    >
      N/A
    </div>) : (
      <Currency
        styleName={standOfferAmtStyle}
        amount={Number(offering.minimumInvestCurrencyAmt)}
        hideCents
      />);
  return (
    <div styleName={offerStyle}>
      {offering.status !== 'closed' && offering.new ? <div styleName={standOfferNewLblStyle}>New!</div> : null}
      {(offering.isComingSoon && offering.status === 'active' && !offering.new) ? <div styleName={standOfferComingSoonLblStyle}>Coming Soon!</div> : null}
      <img
        src={imgSrc}
        alt="Offering thumbnail"
        styleName={standImgStyle}
      />
      <div styleName={offerStatus.styleName}>
        <table style={{ width: '100%' }}>
          <tr>
            <td style={{ width: '50%' }}>
              {offerStatus.display}
            </td>
            <td style={{
                width: '50%',
                textAlign: 'right',
                paddingRight: 12,
                color: 'black',
                fontWeight: 700,
              }}
            >
              {offering.offerType}
            </td>
          </tr>
        </table>
      </div>
      <div styleName={standOfferNameStyle}>
        {offering.name}
      </div>
      <div styleName={standOfferIndStyle}>
        {offering.industry}
      </div>
      <div styleName={standOfferIndStyle}>
        {offering.securityType}
      </div>
      <div styleName="filler" />
      {offering.status === 'closed' && offering.offerOrderSummation ?
        <div styleName={standOfferAmtStyle}>{offering.offerOrderSummation.substring(0, offering.offerOrderSummation.indexOf('.') >= 0 ? offering.offerOrderSummation.indexOf('.') : offering.offerOrderSummation.length)}</div> : currency}
      {offering.status === 'closed' && offering.offerOrderSummation ?
        <div styleName={standOfferMinLblStyle} style={{ color: '#0255A3' }}>Total Investment<sup>*</sup></div> :
        <div styleName={standOfferMinLblStyle}>Minimum Investment</div>}
      <Link to={`/offers/${offering.id}`} styleName="standOfferLink" />
    </div>
  );
};

StandardOffering.propTypes = {
  layout: PropTypes.number.isRequired,
  offering: PropTypes.shape({
    status: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    industry: PropTypes.string.isRequired,
    featured: PropTypes.bool.isRequired,
    minimumInvestCurrencyAmt: PropTypes.number.isRequired,
    assets: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired,
      previewImageUrl: PropTypes.string,
    })),
  }).isRequired,
  showPendingStatus: PropTypes.bool.isRequired,
};

export default StandardOffering;



// WEBPACK FOOTER //
// ./src/components/OfferingList/StandardOffering.js